import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["children", "singleLine", "indentLevel", "width", "className"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import CommonCell from './internal/common-cell';
import OverflowContainer from './internal/overflow-container';
import { indentBase } from './internal/styled';
import withColumnWidth from './internal/with-column-width';
var Cell = /*#__PURE__*/function (_Component) {
  _inherits(Cell, _Component);
  var _super = _createSuper(Cell);
  function Cell() {
    _classCallCheck(this, Cell);
    return _super.apply(this, arguments);
  }
  _createClass(Cell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        singleLine = _this$props.singleLine,
        indentLevel = _this$props.indentLevel,
        width = _this$props.width,
        className = _this$props.className,
        props = _objectWithoutProperties(_this$props, _excluded);
      return (
        /*#__PURE__*/
        // TODO: Determine whether proper `td` elements can be used instead of
        // roles (DSP-11588)
        React.createElement(CommonCell, _extends({
          role: "gridcell",
          indent: indentLevel ? "calc(".concat(indentBase, " * ").concat(indentLevel, ")") : undefined,
          width: width,
          className: className
        }, props), /*#__PURE__*/React.createElement(OverflowContainer, {
          isSingleLine: singleLine
        }, children))
      );
    }
  }]);
  return Cell;
}(Component);
export default withColumnWidth(Cell);